import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import NoNavPage from "./components/NoNavPage";
const LearnMore = () => {
  return (
    <NoNavPage title="Learn More About AptFleet">
      <a id="top" />
      <div className="max-w-2/3 mx-auto py-8 space-y-6">
        <Card className="bg-gray-100 dark:bg-gray-800">
          <CardContent className="p-6 space-y-4">
            <h2 className="text-2xl font-bold">What is AptFleet?</h2>
            <p>
              AptFleet is a modern, cloud-based package management solution
              designed for enterprises and organizations that need seamless
              control over their Linux infrastructure. As a SaaS alternative to
              Ubuntu Landscape, AptFleet enables IT teams to efficiently track,
              manage, and update packages across fleets of Linux servers, all
              from a centralized dashboard.
            </p>
          </CardContent>
        </Card>

        <Card className="bg-gray-200 dark:bg-gray-900">
          <CardContent className="p-6 space-y-4">
            <h2 className="text-2xl font-bold">Why Choose AptFleet?</h2>
            <p>
              Managing software updates across multiple Linux systems can be
              challenging, especially at scale. AptFleet simplifies this process
              with features designed to enhance security, compliance, and
              operational efficiency.
            </p>
            <h3 className="text-xl font-semibold">Key Benefits:</h3>
            <ul className="list-disc list-inside space-y-2">
              <li>
                <strong>Centralized Package Management:</strong> View all
                installed packages and available updates for your managed
                systems in one place.
              </li>
              <li>
                <strong>Automated Update Approvals:</strong> Control which
                updates are applied and when, reducing the risk of system
                instability.
              </li>
              <li>
                <strong>Reboot Tracking:</strong> Easily identify which systems
                require reboots after updates.
              </li>
              <li>
                <strong>Multi-Tenant Support:</strong> Manage multiple
                organizations or business units within a single interface.
              </li>
              <li>
                <strong>Bulk Actions:</strong> Approve and deploy updates across
                multiple systems simultaneously.
              </li>
              <li>
                <strong>API Access:</strong> Integrate AptFleet with your
                existing infrastructure and automation workflows.
              </li>
              <li>
                <strong>Self-Hosted Option (Coming Soon):</strong> Deploy
                AptFleet on your own infrastructure with a custom domain.
              </li>
            </ul>
          </CardContent>
        </Card>

        <Card className="bg-gray-100 dark:bg-gray-800">
          <CardContent className="p-6 space-y-4">
            <h2 className="text-2xl font-bold">How It Works</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                <strong>Install the AptFleet Agent</strong> on your Linux
                machines.
              </li>
              <li>
                <strong>Monitor and Manage</strong> package updates through the
                cloud-based dashboard.
              </li>
              <li>
                <strong>Approve Updates</strong> manually or configure automatic
                update policies.
              </li>
              <li>
                <strong>Track Reboots and System Status</strong> to ensure your
                fleet remains secure and up to date.
              </li>
            </ol>
          </CardContent>
        </Card>

        <Card className="bg-gray-200 dark:bg-gray-900">
          <CardContent className="p-6 space-y-4">
            <h2 className="text-2xl font-bold">
              Supported Linux Distributions
            </h2>
            <p>
              AptFleet is designed to work seamlessly with Debian-based
              distributions, including:
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Ubuntu (all LTS versions)</li>
              <li>Debian (stable releases)</li>
              <li>Other Debian-based derivatives</li>
            </ul>
          </CardContent>
        </Card>

        <Card className="bg-gray-100 dark:bg-gray-800">
          <CardContent className="p-6 space-y-4">
            <h2 className="text-2xl font-bold">Getting Started</h2>
            <p>
              AptFleet offers a <strong>free private beta</strong>, allowing
              users to test and provide feedback before our official launch.
              Sign up today and take control of your Linux package management
              like never before!
            </p>
            <Button asChild className="w-full">
              <a href="/beta-register">Sign Up for Beta Access</a>
            </Button>
          </CardContent>
        </Card>
      </div>
    </NoNavPage>
  );
};

export default LearnMore;
